import { Webhook } from "lucide-react";
import { createLucideIcon } from "./createLucideIcon";

export const WebhookIcon = createLucideIcon(Webhook);
